<template>
  <div class="volo-hotel-search-form" v-if="VOLO_HOTEL_ATTIVITA_ENABLED">
    <div>
      <p class="text-center text-md-left">{{ FORM_DESCRIPTION1 }}</p>
      <ResultMessage :value="resultMessage" />
      <form id="formVoloHotel">
        <div class="row">
          <div class="col-12 inputVolo">
            <div class="form-group">
              <label for="aereoportoId">Aereoporto</label>
              <v-select
                id="aereoportoId"
                class="form-control"
                v-model="search.aereoporto"
                placeholder="Da dove vuoi partire?"
                :options="list"
              />
            </div>
          </div>
          <div class="col-12 inputAndata">
            <div class="form-group">
              <label for="andataId">Andata il</label>
              <CustomDatepicker
                placeholder="Aggiungi data"
                id="andataId"
                v-model="search.andata"
                :disabled-dates="disabledDatesAndata"
                @input="onChangeAndata"
              />
            </div>
          </div>
          <div class="col-12 inputRitorno">
            <div class="form-group">
              <label for="ritornoId">Ritorno il</label>
              <CustomDatepicker
                placeholder="Aggiungi data"
                id="ritornoId"
                v-model="search.ritorno"
                :disabled-dates="disabledDatesRitorno"
              />
            </div>
          </div>
          <div class="col-12 inputPasseggeri">
            <div class="form-group">
              <label for="passeggeriId">Passeggeri</label>
              <CamereSelector
                placeholder="Aggiungi passeggeri"
                id="passeggeriId"
                v-model="search.camere"
              />
            </div>
          </div>
          <div v-if="isMobile" class="col-12 mt-2">
            <button
              id="creaViaggioVoloHotelMobile"
              type="button"
              class="btn btn-primary orange w-100"
              @click="onClick"
              :disabled="!enabledConfirm"
            >
              crea
            </button>
          </div>
        </div>
        <div v-if="!isMobile" class="buttons">
          <button
            id="creaViaggioVoloHotel"
            type="button"
            class="btn btn-primary orange"
            @click="onClick"
            :disabled="!enabledConfirm"
          >
            crea il tuo viaggio
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CustomDatepicker from "../../common/CustomDatePicker";
import CamereSelector from "../../common/CamereSelector";
import { SERVER_DATE_FORMAT } from "../../../../utils/formatter";
import { PRODUCT_VOLO_HOTEL } from "../../../../types/products";
import VoloHotelSearcher from "../../../searcher/VoloHotelSearcher";
import AnalyticEvents from "../../../common/AnalyticEvents";
import MobileDetector from "../../../common/MobileDetector";
import ContentUtils from "../../../utils/ContentUtils";
import ConfigUtils from "../../../utils/ConfigUtils";
import ResultMessage from "../../../pages/layout/common/ResultMessage";

export default {
  name: "VoloHotelSearchForm",
  components: { ResultMessage, CamereSelector, CustomDatepicker },
  mixins: [
    VoloHotelSearcher,
    AnalyticEvents,
    MobileDetector,
    ContentUtils,
    ConfigUtils,
  ],
  data() {
    return {
      disabledDatesAndata: {
        to: new Date(),
      },
      search: {
        product: PRODUCT_VOLO_HOTEL,
        aereoporto: null,
        andata: null,
        ritorno: null,
        camere: [
          {
            adults: 2,
            childs: [],
          },
        ],
      },
    };
  },
  computed: {
    list() {
      return this.getTypesAereoporti().map(function (item) {
        return { label: item.name, value: item.id };
      });
    },
    disabledDatesRitorno() {
      const fromDate = this.$moment(this.search.andata, SERVER_DATE_FORMAT)
        .add(1, "days")
        .toDate();
      return {
        to: fromDate,
      };
    },
    enabledConfirm() {
      const { aereoporto, andata, ritorno } = this.search;
      return aereoporto != null && andata != null && ritorno != null;
    },
  },
  methods: {
    ...mapGetters(["getSearch", "getTypesAereoporti"]),
    onChangeAndata() {
      this.search.ritorno = this.$moment(this.search.andata)
        .add(this.INTERVALLO_GIORNI_IN_RICERCA, "days")
        .toDate();
    },
    onClick() {
      this.trackHomeSearchVoloHotel();
      this.searchAllVoliHotel(this.search);
      this.$emit("change", PRODUCT_VOLO_HOTEL);
    },
  },
  created() {
    /*
    const search = this.getSearch()
    if (search && search.product === PRODUCT_VOLO_HOTEL) {
      this.search = {...search}
    }
    */
  },
};
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/home/VoloHotelSearchForm.vue